<template>
  <vx-card class="overflow-hidden border-2 hover:border-primary" v-on="$listeners">
    <template #no-body>
      <!-- ITEM IMAGE -->
      <div class="bg-white h-56 flex items-center justify-center mb-4 cursor-pointer" @click="navigate_to_detail_view">
        <img :src="product.image" :alt="productLang.name" class="h-56 rounded-lg object-contain">
      </div>

      <div class="px-2">
        <!-- -->
        <div class="w-full flex flex-wrap justify-between">
          <div class="w-2/3 flex justify-start">
            <span class="text-black text-lg md:text-base mr-1 truncate">
              {{ product.code | concat('-') | concat(productLang.name) }}
            </span>
          </div>

          <div class="w-1/3 flex justify-end">
            <h6 class="font-bold text-primary" v-if="$store.state.Profile.isBRL()">{{ calcTotal | BRL }}</h6>
            <h6 class="font-bold text-primary" v-else-if="$store.state.Profile.isUSD()">{{ calcTotal | USD }}</h6>
            <h6 v-else>ERRO</h6>
          </div>
        </div>

        <vs-divider />

        <!-- TITLE & DESCRIPTION -->
        <div class="my-2">
          <p class="text-sm text-justify truncate">
            {{ productLang.description }}
          </p>
        </div>
      </div>

      <!-- SLOT: ACTION BUTTONS -->
      <slot name="action-buttons" :product="product" :productLang="productLang"/>
    </template>
  </vx-card>
</template>

<script>
  export default {
    props: {
      productData: {
        type: Object,
        required: true
      },
    },
    computed: {
      productLang() {
        const locale = this.$i18n.locale;
        return this.product[locale];
      },
      product() {
        return this.productData;
      },
      calcPrice() {
        return this.productData.price;
      },
      calcDiscount() {
        if (this.productData.discount > 0) {
          return (this.productData.price * this.productData.discount / 100);
        }
        return 0;
      },
      calcTotal() {
        return this.calcPrice - this.calcDiscount;
      },
    },
    methods: {
      navigate_to_detail_view() {
        this.$router.push({ name: 'shop-item', params: { item_id: this.productData.id } });
      },
    },
    mounted() {
      console.debug('Mounting GRID VIEW... ', this.productData);
    }
  }
</script>

<style lang="scss" scoped>
  .grid-view-item {
    .grid-view-img {
      max-width: 100%;
      max-height: 100%;
      width: auto;
      transition: .35s;
    }

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, .25);

      .grid-view-img {
        opacity: 0.9;
      }
    }
  }
</style>
